import { apiFetch } from './client'
import type { Category } from '../types'

/** Response shape from the wrapped API: { data: Category[] } */
interface CategoriesResponse {
  data: Category[]
}

export async function fetchCategories(): Promise<Category[]> {
  const res = await apiFetch<CategoriesResponse>('/categories')
  return res.data
}
